<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <component
    :is="wrapperTag || 'div'"
    v-thtml="pagePartHtml"
    :data-part-key="partKey"
    :data-locale-code="localeCode"
  />
</template>

<script setup lang="ts">
import { useRoute } from 'nuxt/app'
import { logger } from '../../../utility/logger'

const props = defineProps<{
  partKey: string
  wrapperTag?: string
}>()

// Dynamically import the HTML file based on the partKey and computed localeCode
const htmlImports = import.meta.glob('../json/*/*.html', {
  query: '?raw',
})

const route = useRoute()
const localeCode = (route.params.lang as string) || 'en-gb'

// Use useLazyAsyncData to lazily fetch and set the page part HTML content
const { data: pagePartHtml } = await useAsyncData(
  `page-part-${props.partKey}`,
  async () => {
    try {
      logger('PagePart.useAsyncData', props.partKey)
      const htmlModule =
        await htmlImports[
          `../json/${localeCode}/${encodeURIComponent(props.partKey)}.html`
        ]()
      return htmlModule.default || htmlModule
    } catch (error) {
      console.error('Error loading page part:', error)
      return ''
    }
  },
  // this stops the double fetch from server and client
  {
    server: true,
    lazy: process.client,
    dedupe: 'cancel',
    getCachedData: (key, nuxt) => nuxt.payload.data[key] ?? undefined,
  },
)
</script>
